import { defineStore } from 'pinia'

export const usePDPAStore = defineStore('pdpa', () => {
  const _id = ref('')
  const show = ref(false)
  const title = ref('')
  const content = ref('')
  const metaTitle = ref('')
  const metaDescription = ref('')
  const ogImage = ref<ImageMeta>()
  const { $api } = useNuxtApp()

  const fetch = async () => {
    const response = await $api<ApiSuccessResponse<PDPA>>('/pdpa')
    const data = response.data
    if (data) {
      update(data)
    }
  }

  const update = (payload: PDPA) => {
    _id.value = payload._id
    show.value = payload.show
    title.value = payload.title
    content.value = payload.content
    metaTitle.value = payload.metaTitle
    metaDescription.value = payload.metaDescription
    ogImage.value = payload.ogImage
  }

  return {
    _id,
    show,
    title,
    content,
    metaTitle,
    metaDescription,
    ogImage,
    fetch,
    update,
  }
})
